module.exports = __webpack_public_path__ + "img/freestyle.2631bb30.png";